import { useLang } from "hooks/useLang"

const organizer = {
    name: "Saudi Motorsport",
    desc: "The dedicated entity driving the growth of motorsport in Saudi Arabia."
}

const organizer_ar = {
    name: " جائزة السعودية الكبرى STC للفورمولا 1",
    desc: "شركة رياضة المحركات السعودية."
}
const F1Organizer = () => {
    const { lang } = useLang()
    const data = lang === "ar" ? organizer_ar : organizer
    return (
        <div className="flex items-center flex-col gap-4 w-full md:w-[75%] ">
            <div className="w-[100px]  rounded-full " >
                <img src={"https://passticketsstorage.blob.core.windows.net/images/f1-2025" + "/f1/organizer/org.png"} alt={data.name} className="w-full h-full overflow-hidden" />
            </div>
            <div className="flex flex-col w-full items-center gap-4">
                <span className="text-[26px] font-[500]">{data?.name}</span>
                <span className="text-[16px] font-light text-center w-[55%]">{data?.desc}</span>
            </div>
        </div>
    )
}

export default F1Organizer
